import { Schema } from 'effect';
import { SiteId } from './common.js';
/**
 * DTO schemas for the admin invoicing endpoints (`/admin/invoices/*`).
 * Separate namespace from `AdminSchemas` — different sub-router.
 * See http/payment.ts for conventions.
 */
export const InvoiceListParams = Schema.Struct({ siteId: SiteId });
export const InvoiceParams = Schema.Struct({
    siteId: SiteId,
    invoiceNumber: Schema.String
});
export const InvoiceListQuery = Schema.Struct({
    status: Schema.optional(Schema.String),
    customerId: Schema.optional(Schema.String),
    fromDate: Schema.optional(Schema.String),
    toDate: Schema.optional(Schema.String),
    limit: Schema.optional(Schema.String),
    log: Schema.optional(Schema.String)
});
export const InvoiceListResponse = Schema.Struct({
    invoices: Schema.mutable(Schema.Array(Schema.Any)),
    total: Schema.Number
});
export const PaymentBody = Schema.Struct({
    amount: Schema.Number.pipe(Schema.check(Schema.isGreaterThan(0))),
    note: Schema.optional(Schema.String)
});
export const CreditBody = Schema.Struct({
    reason: Schema.String.pipe(Schema.check(Schema.makeFilter((s) => s.trim().length > 0))),
    partialAmount: Schema.optional(Schema.Number.pipe(Schema.check(Schema.isGreaterThan(0))))
});
export const ResendEmailBody = Schema.Struct({
    additionalEmail: Schema.optional(Schema.String)
});
export const ReminderBody = Schema.Struct({
    customMessage: Schema.optional(Schema.String),
    additionalEmail: Schema.optional(Schema.String)
});
export const MessageResponse = Schema.Struct({ message: Schema.String });
export const CreditResponse = Schema.Struct({
    message: Schema.String,
    creditNote: Schema.Struct({
        creditNoteNumber: Schema.Number,
        totalAmount: Schema.Number
    })
});
export const EmailsSentResponse = Schema.Struct({
    message: Schema.String,
    emailsSent: Schema.mutable(Schema.Array(Schema.String))
});
//# sourceMappingURL=adminInvoice.js.map